export default __webpack_public_path__ + "static/media/Hellfire.1c8df9a7.jpg";